import React from "react";
import { Card, CardActionArea, Grid, Stack, Typography } from "@mui/material";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { useNavigate } from "react-router";
import { PATHS } from "../routing/paths";
import PeopleIcon from "@mui/icons-material/People";

export default function Dashboard() {
  const navigate = useNavigate();
  return (
    <Stack spacing={2}>

      <Typography variant="h4" sx={{ wordBreak: "break-word" }}>
        Dashboard
      </Typography>

      <Grid container spacing={{ xs: 2 }} columns={{ xs: 1, sm: 2, md: 2 }}>
        <Grid size={{ xs: 1, sm: 1, md: 1 }}>
          <Card variant="outlined" sx={{ p: 2 }}>
            <CardActionArea onClick={() => navigate(PATHS.openingHours)}>
              <Stack spacing={2} alignItems="center">
                <ScheduleIcon fontSize="large" />
                <Typography variant="h6">Öffnungszeitenverwaltung</Typography>
              </Stack>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid size={{ xs: 1, sm: 1, md: 1 }}>
          <Card variant="outlined" sx={{ p: 2 }}>
            <CardActionArea onClick={() => navigate(PATHS.staff)}>
              <Stack spacing={2} alignItems="center">
                <PeopleIcon fontSize="large" />
                <Typography variant="h6">Personalverwaltung</Typography>
              </Stack>
            </CardActionArea>
          </Card>
        </Grid>
      </Grid>

    </Stack>
  );
}
